import * as React from "react";

export interface TestFrameProps{
    startTest:(e:any)=>void,
    videosLoaded:number
}

export class StartTestFrame extends React.Component<TestFrameProps,undefined>{
    constructor(props){
        super(props);
        this.startTest       = this.startTest.bind(this);
    }

    private startTest(e) {
        this.props.startTest(e);
    }

    render() {
        return (
            <div className={'frame _start-image'}>
                <div className={'frame-image _start-image' }>
                    <div className={'frame-image__pic'  + (this.props.videosLoaded > 5 ? '' : ' _hidden')}/>
                </div>
                <div className={'button _start'  + (this.props.videosLoaded > 5 ? '' : ' _hidden')} onClick={this.startTest}>
                    Начать
                    <svg className='svg-icon play-button'>
                        <use xlinkHref='#icon-play-button' />
                    </svg>
                </div>
            </div>
        );
    }
}